export default "__VITE_PUBLIC_ASSET__84e2437c__"